import type { ThemeConfig } from 'antd';

/**
 * Ant Design 主题配置
 * 使用默认主题，仅自定义主色调
 */

export const antdTheme: ThemeConfig = {
  token: {
    // 主色调 - 橙色主题
    colorPrimary: '#f97316',
    colorLink: '#f97316',
    colorLinkHover: '#fb923c',
    colorLinkActive: '#ea580c',

    // 圆角
    borderRadius: 8,

    // 字体
    fontFamily:
      '"Space Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',

    // 边框和背景
    colorBorder: '#e4e4e7',
    colorBorderSecondary: '#f4f4f5',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#fafafa',

    // 表单控件聚焦时保留主色边框，但不渲染边框外的额外光圈。
    controlOutline: 'transparent',
    controlOutlineWidth: 0,
  },
};

// 导出暗色和亮色主题（如果需要切换）
export const darkTheme = antdTheme;
export const lightTheme = antdTheme;
